module.exports = __webpack_public_path__ + "img/Icon-Sort-by-black.ee704185.svg";